import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Code } from 'lucide-react';

const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1644175283530-5b6e6ed80b2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxhYnN0cmFjdCUyMGJsdWUlMjBxdWFudHVtJTIwdGVjaG5vbG9neSUyMGRpZ2l0YWwlMjB3YXZlfGVufDB8fHx8MTc2NjA1MzE4N3ww&ixlib=rb-4.1.0&q=85')",
          }}
        />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-blue-900/20 via-slate-950 to-slate-950" />
      </div>

      {/* Grid Pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] z-0" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="flex items-center justify-center mb-6">
            <Code className="text-blue-500 mr-3" size={32} />
            <p className="text-sm uppercase tracking-widest text-blue-500 font-mono" data-testid="hero-label">
              Software House
            </p>
          </div>

          <h1
            data-testid="hero-title"
            className="text-5xl md:text-7xl font-outfit font-bold tracking-tight mb-6"
          >
            <span className="bg-gradient-to-r from-blue-500 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Building the Digital Future
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-400 max-w-2xl mx-auto mb-12 font-inter leading-relaxed" data-testid="hero-description">
            Quantum Byte Studio transforms complex problems into elegant software solutions.
            We craft cutting-edge applications that drive business growth.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-primary"
              className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-inter font-medium transition-all duration-200 hover:shadow-[0_0_20px_rgba(59,130,246,0.3)] flex items-center"
            >
              Start a Project
              <ArrowRight className="ml-2" size={20} />
            </a>
            <a
              href="#portfolio"
              data-testid="hero-cta-secondary"
              className="px-8 py-4 border border-blue-500/20 hover:border-blue-500/50 text-white rounded-lg font-inter font-medium transition-all duration-200 hover:shadow-[0_0_15px_rgba(59,130,246,0.1)]"
            >
              View Work
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;